// extracted by mini-css-extract-plugin
export default {"lang":"LangPicker_lang__ydo63"};